import isNil from 'lodash/isNil';

export const normalizeDate = () => (value, prevValue) => {
    const dateValue = value;
    if (dateValue) {
        if (dateValue.length < 11) {
            if (isNil(prevValue) || prevValue.length < dateValue.length) {
                const onlyNums = dateValue.replace(/[^\d]/g, '');
                const inputArray = onlyNums.split('');
                if (inputArray.length > 0) {
                    const newNumberMask = ['_', '_', '/', '_', '_', '/', '_', '_', '_', '_'];
                    let idx = onlyNums.length;
                    inputArray.map((i) => {
                        const regex = /\d/;
                        if (regex.test(i)) {
                            idx = newNumberMask.indexOf('_');
                            newNumberMask[idx] = i;
                            return i;
                        }
                        return null;
                    });
                    return newNumberMask.slice(0, idx + 1).join('');
                }
                return ' ';
            }
        } else {
            return value.substring(0, value.length - 1);
        }
    }
    return dateValue;
};

export default {
    normalizeDate,
};
